import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapDCompanyToApiDCompanyDto = (values: IEditDCompanyForm): IPostEditDCompany | {} => {
  let dataMapping: IPostEditDCompany ;
  const unknown = -1;

  dataMapping = {
    description: values.description,
    placeID: +values.placeID !== 0 ? +values.placeID : unknown,
    modemID: +values.modemID !== 0 ? +values.modemID : unknown,
    modemPort: values.modemPort,
    unID: values.unID,
    sapCode: values.sapCode,
    deleted: false,
    filepath:values.filepath,
    hubType: values.hubType,
    anetVoice: values.anetVoice,
    comments: values.comments,
    isEmporiki: values.isEmporiki,
    isCiti: values.isCiti,
  }
  
  return dataMapping;
}


const editDCompany = ( {data, dCompanyId} : {data: IEditDCompanyForm , dCompanyId: number}): Promise<string> => {
  const dCompany = mapDCompanyToApiDCompanyDto(data);
  return axiosDefaultApi.put(`/api/DCompanies/UpdateDCompany/${dCompanyId}`, dCompany);
};

type QueryFnType = typeof editDCompany;

type UseEditDCompanyOptions = {
  data: IPostEditDCompany | {};
  dCompanyId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditDCompany = ({ config }: UseEditDCompanyOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Θυγατρικής.`, 500);
            console.error('Couldnt edit DCompany', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllDCompanies"])
            addNotification('Η Θυγατρική Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editDCompany,
    })
}